module.exports = __webpack_public_path__ + "img/newicon5click.0d8b9869.svg";